var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
class ScriptGenResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "");
  }
  loadSparkSqlResponse(_0, _1) {
    return __async(this, arguments, function* (workspaceId, scorecardId, requiredMetrics = ["QCNT"]) {
      let address = `https://generatorservice-api-ame-prod-cus.azurewebsites.net/workspaces/${workspaceId}/spark-sql?scorecardId=${scorecardId}`;
      if (requiredMetrics.length > 0) {
        address += `&requiredMetrics=${requiredMetrics.join(",")}`;
      }
      return yield this._get(address);
    });
  }
}
const ScriptGenResource$1 = new ScriptGenResource();
export {
  ScriptGenResource,
  ScriptGenResource$1 as default
};
//# sourceMappingURL=ScriptGenResource.js.map
